import _, {property} from 'lodash';
import * as actionTypes from '../../constants/actionTypes';
import {showJobBoardExport, loadingDialog_show, messageBox_Show} from '../../actions/A_Popups';
import {getApiConfig, getCurrentFabricatorId} from '../../utilities/index';
import moment from 'moment';
import {toggleJobBoardFilterArrayValue, toggleJobBoardFilterSimpleValue} from "../../utilities/job";
import {SEND_EMAIL_CHECKBOXES} from "./JobBoardReducer";

// Internet Explorer 6-11
let isIE = /*@cc_on!@*/false || !!document.documentMode;
// https://stackoverflow.com/questions/49328382/browser-detection-in-reactjs

function shouldFetchJobs(state) {
  const {jobBoard} = state;

  if (!jobBoard.sentinel) {
    return true;
  } else if (jobBoard.fetching) {
    return false;
  }
  return jobBoard.invalidated;
}

/**
 * internal same post function
 *
 * @param dispatch {function}
 * @param jobBoardState {array}
 * @returns {PromiseLike}
 */
const _postJobs = (dispatch, jobBoardState) => {
  const {term, page, filters, sortBy, relatedJobs} = jobBoardState;
  const {post} = getApiConfig('JobBoard/GetJobs');
  dispatch(loadingDialog_show(true, "loader.loading", "loader.receivingJobsList", true));
  return post({
    state: '',
    searchTerm: term,
    mode: 'client',
    page,
    filters: Array.isArray(filters) ? filters.filter(filter => {
      return !(filter.value && Array.isArray(filter.value) && !filter.value.length); // remove empty values
    }) : [],
    sortBy,
  }).then(result => {
    dispatch({
      type: actionTypes.JOB_BOARD_LOADED,
      payload: {...result, relatedJobs},
    });
    dispatch(loadingDialog_show(false));
    return result
  });
};

/**
 *
 * @param page {int} Needed page
 * @param term {string} Search term
 * @param force {boolean} Force reload
 * @returns {Function}
 */
export function fetchJobs(page, term, force) {
  return async function (dispatch, getState) {
    const state = getState();
    if (shouldFetchJobs(state) || page !== state.jobBoard.page || force) {
      dispatch({type: actionTypes.JOB_BOARD_LOADING});

      const fabricatorId = getCurrentFabricatorId(getState());
      let responseRelated = state.jobBoard.relatedJobs;
      if (!state.jobBoard.relatedJobsFabricatorId || (state.jobBoard.relatedJobsFabricatorId !== fabricatorId)) {
        try {
          responseRelated = await getApiConfig(`JobBoard/${fabricatorId}/jobs/related`).get();
        } catch (error) {
          responseRelated = [];
        }
      }

      return _postJobs(dispatch, {...state.jobBoard, term, page, relatedJobs: responseRelated});
    }
    return null;
  };
}

/**
 *
 * @param page {int} Needed page
 * @returns {Function}
 */
export function fetchJobsForNotifications(page) {
  return function () {
    const {post} = getApiConfig('JobBoard/GetJobs');
    return post({state: "", mode: "client", page, filters: [], sortBy: []})
  };
}

export function changeJobStatus() {
  return function (dispatch, getState) {
    let state = getState();
    const {post} = getApiConfig('JobBoard/ChangeJobStatus');

    const job = state.jobBoard.logEntryJob;
    const sendEmailCheckboxes = state.jobBoard.sendEmailCheckboxes;
    // console.log("jobjobjob1", job);

    dispatch(loadingDialog_show(true, "loader.loading", "loader.updatingJob", true));

    return post({
      action: job.action,
      jobId: job.jobId,
      jobIdType: job.jobIdType,
      oldLeadType: job.oldLeadType,
      newLeadType: job.newLeadType, // this could be status or lead type, depending on the action!
      text: job.logEntry.message,
      userId: state.auth.userId,
      logEntryId: job.logEntry.id,
      type: job.type,
      isDead: job.isDead,
      ...SEND_EMAIL_CHECKBOXES.reduce((total, property) => {
        return {...total, [property]: sendEmailCheckboxes.includes(property)}
      }, {}),
    }).then(result => {
      // console.log("jobjobjob22222 result", result);
      dispatch({
        type: actionTypes.JOB_BOARD_JOB_STATUS_CHANGED,
        payload: result
      });
      dispatch(loadingDialog_show(false));
      dispatch(toggleShowJobBoardLogEntryPopup(false));
    })
      .then(() => {
        //after we saved a job - update new log entries, as the job is still opened
        dispatch(loadJobLogEntries({
          id: job.jobId,
          type: job.action === "changeLeadType" ? job.newLeadType : job.type,
        }));
        // console.log('refresh data');
        // if (job.action !== 'update') {
        //   dispatch(fetchJobs(state.jobBoard.page + 1, '', true));
        // }
      })
      .catch((error) => {
        console.log("error", new Error(error));
        dispatch(loadingDialog_show(false));
        dispatch(toggleShowJobBoardLogEntryPopup(false));
      });
  }
}


export function expandJob(job) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_EXPAND_JOB,
      payload: job
    });
  }
}

export function toggleJobTypeDropDownVisibility() {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_TOGGLE_JOBTYPE_DROPDOWN,
      payload: {}
    });
  }
}

export function showQuoteEditLayer(job, show) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_SHOW_QUOTEEDIT_LAYER,
      payload: {job: job, show: show}
    });
  }
}

export function showLeadTypeDropDown(show) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_SHOW_LEADTYPE_DROPDOWN,
      payload: show
    })
  }
}

export function showJobStatusDropDown(show) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_SHOW_JOBSTATUS_DROPDOWN,
      payload: show
    })
  }
}

export function loadJobLogEntries(job) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.JOB_BOARD_LOG_ENTRIES_LOADING,
      payload: {id: job.id, type: job.type}
    });

    const {post} = getApiConfig('JobBoard/GetJobBoardLogEntries');
    return post({
      id: job.id,
      type: job.type
    }).then(result => {
      dispatch({
        type: actionTypes.JOB_BOARD_LOG_ENTRIES_LOADED,
        payload: result
      })
    });
  }
}

export function loadJobMessageHistory(job) {
  return function (dispatch) {
    dispatch({
      type: actionTypes.JOB_BOARD_MESSAGE_HISTORY_LOADING,
      payload: {id: job.id, type: job.type}
    });

    const {get} = getApiConfig(`PingMessageHistory/${job.id}/${job.type}`);
    return get().then(result => {
      dispatch({
        type: actionTypes.JOB_BOARD_MESSAGE_HISTORY_LOADED,
        payload: result
      })
    });
  }
}

// export function setFilter(name, value, replaceValue = false, multipleValues = false) {
export function setFilters(filters) {
  return function (dispatch, getState) {

    const state = getState();

    // filters = multipleValues
    //   ? toggleJobBoardFilterArrayValue(filters, name, value)
    //   : toggleJobBoardFilterSimpleValue(filters, {name, value}, replaceValue)

    dispatch({
      type: actionTypes.JOB_BOARD_SHOW_FILTER,
      payload: filters
    });

    return _postJobs(dispatch, {...state.jobBoard, filters});
  }
}
export function setJobBoardSortBy(sortBy) {
  return function (dispatch, getState) {

    const state = getState();

    dispatch({
      type: actionTypes.JOB_BOARD_SET_SORTING,
      payload: sortBy
    });

    return _postJobs(dispatch, {...state.jobBoard, page: 0, sortBy});
  }
}

export function jobBoardSetSearchTerm(term) {
  return function (dispatch, getState) {
    const state = getState();

    dispatch({
      type: actionTypes.JOB_BOARD_SET_SEARCH_TERM,
      payload: term
    });

    return _postJobs(dispatch, {...state.jobBoard, term, page: 0});
  }
}

export function jobBoardResetFilters(nameOnly) {
  return function (dispatch, getState) {
    const state = getState();
    const {filters} = state.jobBoard;
    if (nameOnly) {
      let index = filters.findIndex(fObject => fObject.name === nameOnly);
      if (index >= 0) {
        filters.splice(index, 1) // remove
      }
    }
    return _postJobs(dispatch, {...state.jobBoard, page: 0, filters: nameOnly ? filters : []});
  }
}

export function editJobLogEntry(job, logEntry) {
  return function (dispatch) {

  }
}

export function jobBoardShowJobScheduling(job, show) {
  return function (dispatch, getState) {
    // if (!job) {
      // calendar entry window gets closed, check if we have any changes, and if we do
      // then we need to fetch the jobs entries again
      // const {calendar} = getState();
      // if (calendar.hasChanges) {
      //   const {jobBoard} = getState();
      //   fetchJobs(jobBoard.page + 1, jobBoard.searchTerm, true)(dispatch, getState);
      // }
    // }
    dispatch({
      type: actionTypes.CALENDAR_SHOW,
      payload: {
        job: job,
        show: show
      }
    });
  }
}

export function uploadExclusionList(csv) {
  return (dispatch) => {
    const {post} = getApiConfig('JobBoard');
    if(isIE) {
      dispatch(messageBox_Show(true, "error", "Internet Explorer Detected", "Download feature not available in Internet Explorer."));
    } else {
      dispatch(loadingDialog_show(true, "Uploading...", "Uploading Exclusion List, please wait..."));
      return post({data: csv}, 'UploadExclusionList')
        .then(() => dispatch(loadingDialog_show(false)));
    }
  }
}

export function downloadExclusionList() {
  return dispatch => {
    dispatch(loadingDialog_show(true, "Downloading...", "Gathering exclusion list data, please wait..."));
    const {get} = getApiConfig('JobBoard');
    return get('/DownloadExclusionList')
    .then((data) => {
      const anchor = document.createElement('a');
      const windowUrl = window.URL || window.webkitURL;
      const file = new Blob([data.fileContents], {type: "text/csv"});
      const url = windowUrl.createObjectURL(file);
      document.body.appendChild(anchor);
      anchor.setAttribute('href', url);
      anchor.setAttribute('download', data.fileName);
      anchor.click();
      anchor.remove();
      setTimeout(function(){
        windowUrl.revokeObjectURL(url);
      }, 100);
      dispatch(loadingDialog_show(false));
    });
  }
}

export function jobBoardExport(data) {
  return function(dispatch, getState) {
    const {post} = getApiConfig('JobBoard');
    const state = getState();
    if(!data.download && !data.email) {
      dispatch(messageBox_Show(true, 'system', 'Unknown Delivery Method', 'Please select how you want to receive the export by checking Download and/or Email'));
      return;
    }
    if(data.email && !data.emailAddress) {
      dispatch(messageBox_Show(true, 'system', 'Missing Email Address', 'Please enter an e-mail address to receive the export e-mail'));
      return;
    }
    if(data.email && !/\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i.test(data.emailAddress)) {
      dispatch(messageBox_Show(true, 'system', 'Invalid Email Address', 'The Email Address you entered does not appear to be valid.'));
      return;
    }
    if(data.email && !data.emailMessage) {
      data.emailMessage = "Attached is your requested Job Board data.";
    }
    if(data.useDateRange) {
      let dateFrom = moment(data.dateRangeFrom, "YYYY-MM-DD");
      let dateTo = moment(data.dateRangeTo, "YYYY-MM-DD");
      let now = moment();
      if(!dateFrom.isValid()) {
        dispatch(messageBox_Show(true, 'system', 'Invalid From Date', 'From Date Format is invalid.'));
        return;
      }
      if(!dateTo.isValid()) {
        dispatch(messageBox_Show(true, 'system', 'Invalid To Date', 'To Date Format is invalid.'));
        return;
      }
      if(dateTo.isSameOrBefore(dateFrom)) {
        dispatch(messageBox_Show(true, 'system', 'Invalid Date Range', 'To Date must be after From Date.'));
        return;
      }
      if(dateFrom.isAfter(now)) {
        dispatch(messageBox_Show(true, 'system', 'Invalid Date Range', 'From Date cannot be in the future.'));
        return;
      }
    }
    dispatch(loadingDialog_show(true, "Exporting...", "Generating export data, please wait..."));
    const {term, page, filters} = state.jobBoard;
    if(data.download) {
      if(isIE) {
        dispatch(messageBox_Show(true, "error", "Internet Explorer Detected", "Download feature not available in Internet Explorer."));
      } else {
        post({
          searchTerm: term,
          excludeDuplicates: data.excludeDuplicates,
          useDateRange: data.useDateRange,
          dateRangeFrom: data.dateRangeFrom,
          dateRangeTo: data.dateRangeTo,
          page,
          filters
        }, 'JobBoardExportDownload').then(data => {
          const anchor = document.createElement('a');
          const windowUrl = window.URL || window.webkitURL;
          const file = new Blob([data.fileContents], {type: "text/csv"});
          const url = windowUrl.createObjectURL(file);
          document.body.appendChild(anchor);
          anchor.setAttribute('href', url);
          anchor.setAttribute('download', data.fileName);
          anchor.click();
          anchor.remove();
          setTimeout(function(){
            windowUrl.revokeObjectURL(url);
          }, 100);
          dispatch(showJobBoardExport(false));
          dispatch(loadingDialog_show(false));
        }).catch(data => {
          dispatch(loadingDialog_show(false));
        });
      }
    }
    if(data.email) {
      post({
        emailAddress: data.emailAddress,
        message: data.emailMessage,
        excludeDuplicates: data.excludeDuplicates,
        useDateRange: data.useDateRange,
        dateRangeFrom: data.dateRangeFrom,
        dateRangeTo: data.dateRangeTo,
        filters,
        searchTerm: term,
        page
      }, 'JobBoardExportEmail').then(() => {
        dispatch(showJobBoardExport(false));
        dispatch(loadingDialog_show(false));
      });
    }
  }
}

export function toggleShowJobBoardLogEntryPopup(show) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.JOB_BOARD_SHOW_LOG_WINDOW,
      payload: {show}
    });
  }
}

export function updateJob(job, properties = {}) {
  return {
    type: actionTypes.JOB_BOARD_UPDATE_JOB,
    payload: {job, properties}
  }
}

export function updateJobName(job, customName) {
  return function (dispatch) {
    const {post} = getApiConfig('JobBoard/UpdateJobCustomName');
    dispatch(loadingDialog_show(true, "loader.loading", "loader.updatingJob", true));
    return post({
      jobId: job.id,
      customName,
    })
      .then(result => {
        // console.log("UpdateJobCustomName result", result);
        dispatch(loadingDialog_show(false));
        return result
      })
      .catch((error) => {
        console.log("error", new Error(error));
        dispatch(loadingDialog_show(false));
        return false
      });
  }
}

export const setSendEmailCheckboxes = (sendEmailCheckboxes) => ({
  type: actionTypes.JOB_BOARD_SET_SEND_EMAIL_CHECKBOXES,
  payload: {sendEmailCheckboxes}
})

export const setJobBoardRelatedJobs = (relatedJobs, relatedJobsFabricatorId) => ({
  type: actionTypes.JOB_BOARD_SET_RELATED_JOBS,
  payload: {relatedJobs, relatedJobsFabricatorId}
})
